import {
	API_AWARD,
	API_BUDGET_BUILDER,
	API_PROPOSAL,
	API_USER_TASKS,
	FLOWABLE_BASE_URL,
	MAX_TASKS_SHOWED,
} from "globals/constants";
import { buildSearchParams, spUrl } from "utils";
import { put, request, save } from "utils/proxy";


export const tasks = {
	get: (params, options) => {
		return request(
			`${FLOWABLE_BASE_URL}/cayuse-api/query/tasks/admin-platform-my-tasks-v2/nested${buildSearchParams(params)}`,
			options,
		);
	},

	/**
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	getUserTasks: options => request(spUrl(`${API_USER_TASKS}?size=${MAX_TASKS_SHOWED + 1}`), options),

	/**
	 * @param {{instanceEndpoint: string, instanceId: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	saveReview: (params, body, options) =>
		put(spUrl(`${params.instanceEndpoint}/${params.instanceId}/review`), body, options),

	saveReviews: (params, body, options) =>
		put(spUrl(`${params.instanceEndpoint}/${params.instanceId}/reviews`), body, options),

	saveTask: (taskId, body, options) =>
		save(`${FLOWABLE_BASE_URL}/platform-api/tasks/${taskId}/complete`, body, options),

	getAwardTasks: (params, options) => request(spUrl(`${API_AWARD}/${params.id}/tasks`), options),
	getProposalTasks: (params, options) => request(spUrl(`${API_PROPOSAL}/${params.id}/tasks`), options),

	/**
	 * @param {{id: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	saveBudgetBuilderTask: (params, body, options) =>
		save(`${API_BUDGET_BUILDER}/tasks/${params.id}/complete`, body, options),

	/**
	 * @param {{instanceAPI: string, instanceId: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	create: (params, body, options) =>
		save(spUrl(`${params.instanceAPI}/${params.instanceId}/tasks`), body, options),

	/**
	 * @param {{instanceAPI: string, instanceId: string, id: string}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	edit: (params, body, options) =>
		put(spUrl(`${params.instanceAPI}/${params.instanceId}/tasks/${params.id}`), body, options),
};
